<template>
    <v-dialog v-model="isOpen" persistent width="536px" class="contact-modal">
        <v-card class="contact-modal__card">
            <v-card-text class="contact-modal__card-title px-0">
                Contáctenos
            </v-card-text>
            <v-card-text>
                <v-text-field
                    label="Nombre"
                    v-model="name"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                ></v-text-field>
                <v-text-field
                    label="Dirección de correo electrónico (OBLIGATORIO)"
                    v-model="email"
                    hide-details
                    dense
                    filled
                    required
                    class="mx-auto my-3"
                ></v-text-field>
                <v-text-field
                    label="Asunto"
                    v-model="subject"
                    hide-details
                    dense
                    filled
                    class="mx-auto my-3"
                ></v-text-field>
                <v-textarea
                    label="Descripción (OBLIGATORIO)"
                    v-model="description"
                    hide-details
                    dense
                    filled
                    required
                    class="mx-auto my-3"
                ></v-textarea>
            </v-card-text>
            <v-card-actions class="contact-modal__card-actions">
                <v-btn
                    @click="closeModal"
                    outlined
                    color="#3BADFF"
                    dark
                    :disabled="isLoading"
                >
                    Cancelar
                </v-btn>
                <v-btn
                    @click="submitForm"
                    outlined
                    color="#3BADFF"
                    :class="{
                        'white--text': isLoading,
                        'dark': !isLoading
                    }"
                    :disabled="isLoading || !isValidForm"
                >
                    Enviar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>    
</template>

<script>
export default {
    name: "ContactModal",
    props: {
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isLoading: false,
            name: "",
            email: "",
            subject: "",
            description: ""
        };
    },
    computed: {
        isValidForm() {
            return this.email && this.description;
        }
    },
    methods: {
        closeModal() {
            this.clearForm();
            this.$emit("close");
        },
        clearForm() {
            this.name = "";
            this.email = "";
            this.subject = "";
            this.description = "";
        },
        submitForm() {
            if (this.isValidForm) {
                const mailtoLink = `mailto:hola@trabajoconsentido.com?subject=${encodeURIComponent(this.subject)}&body=Nombre:%20${encodeURIComponent(this.name)}%0D%0AEmail:%20${encodeURIComponent(this.email)}%0D%0ADescripción:%20${encodeURIComponent(this.description)}`;
                window.location.href = mailtoLink;
                this.clearForm();
                this.closeModal();
            }
        }
    }
};
</script>

<style scoped>
.contact-modal__card {
  padding: 20px;
}

.contact-modal__card-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}

.contact-modal__card-actions {
  justify-content: flex-end;
}
</style>
